import articleBulletins from "./work-articles/articleBulletins";
import articleMandyLynn from "./work-articles/articleMandyLynn";
import articleTechAddictionQuiz from "./work-articles/articleTechAddictionQuiz";
import articleAnimationShowcase from "./work-articles/articleAnimationShowcase";
import articleMusicVideo from "./work-articles/articleMusicVideo";

const work_graphicDesign = [
  articleTechAddictionQuiz,
  articleBulletins,
  articleMandyLynn,
  articleMusicVideo,
  articleAnimationShowcase,
]
export default work_graphicDesign;